import { computed, openBlock, createElementBlock, renderSlot, normalizeClass, Fragment, createTextVNode, toDisplayString, createCommentVNode, createBlock, withCtx } from "vue";
import UikitHelp from "../Help.vue.es.js";
/* empty css             */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = { class: "cell" };
const _hoisted_2 = {
  key: 0,
  class: "title"
};
const _hoisted_3 = {
  key: 0,
  class: "sub-title"
};
const _hoisted_4 = {
  key: 1,
  class: "required-mark"
};
const _sfc_main = {
  __name: "Cell",
  props: {
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    },
    emptyTitle: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const hasTitle = computed(() => props.title !== "" || props.emptyTitle);
    const hasSubTitle = computed(() => props.subTitle !== "");
    const displayHint = computed(() => props.hint !== "");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        _ctx.$slots.title ? (openBlock(), createElementBlock("div", _hoisted_2, [
          renderSlot(_ctx.$slots, "title", {}, void 0, true)
        ])) : hasTitle.value ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["title", { "u-hide-mobile": __props.emptyTitle }])
        }, [
          __props.emptyTitle ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(" ‍ ")
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(toDisplayString(__props.title) + " ", 1),
            hasSubTitle.value ? (openBlock(), createElementBlock("span", _hoisted_3, toDisplayString(__props.subTitle), 1)) : createCommentVNode("", true),
            __props.required ? (openBlock(), createElementBlock("span", _hoisted_4, " * ")) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "title-right", {}, () => [
              displayHint.value ? (openBlock(), createBlock(UikitHelp, { key: 0 }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(__props.hint), 1)
                ]),
                _: 1
              })) : createCommentVNode("", true)
            ], true)
          ], 64))
        ], 2)) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]);
    };
  }
};
const Cell = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-06c32bfb"]]);
export {
  Cell as default
};
//# sourceMappingURL=Cell.vue.es.js.map
